export class VendorModel {
    vendor_code: string
    vendor_name: string
    contact: string
    order_phone_no: string
    cust_service_no: string
    fax_no: string
    email_address: string
    street_address: string
    vendor_zip: string
    vendor_zip_ext: string
    vendor_active: boolean
    delivery_time: number
    vendor_acct_no: string
    vendor_message: string

    constructor(
        vendor_code: string,
        vendor_name: string,
        contact: string,
        order_phone_no: string,
        cust_service_no: string,
        fax_no: string,
        email_address: string,
        street_address: string,
        vendor_zip: string,
        vendor_zip_ext: string,
        vendor_active: boolean,
        delivery_time: number,
        vendor_acct_no: string,
        vendor_message: string
    ) {
        this.vendor_code = vendor_code
        this.vendor_name = vendor_name
        this.contact = contact
        this.order_phone_no = order_phone_no
        this.cust_service_no = cust_service_no
        this.fax_no = fax_no
        this.email_address = email_address
        this.street_address = street_address
        this.vendor_zip = vendor_zip
        this.vendor_zip_ext = vendor_zip_ext
        this.vendor_active = vendor_active
        this.delivery_time = delivery_time
        this.vendor_acct_no = vendor_acct_no
        this.vendor_message = vendor_message
    }
}